module.exports = __webpack_public_path__ + "static/media/nodata.a86cd7d5.svg";